import React from "react";
import "../styles/MockInterviews.css";

const MockInterviews = () => {
  return (
    <div className="mock-interviews-page">
      <h1>🎤 Practice Mock Interviews</h1>
      <p>Boost your confidence with real-time mock interview sessions.</p>

      <section className="mock-interview-options">
        <h2>💼 Choose Your Mock Interview Type</h2>
        <ul>
          <li>📌 **Technical Interviews** (DSA, System Design, Frontend, Backend)</li>
          <li>📌 **Behavioral Interviews** (HR, Situational Questions, STAR Method)</li>
          <li>📌 **Product-Based Company Interviews** (Google, Amazon, Microsoft, etc.)</li>
        </ul>
      </section>

      <section className="book-session">
        <h2>🚀 Get Real Feedback from Experts</h2>
        <button className="btn primary-btn">Book a Free Mock Interview</button>
      </section>
    </div>
  );
};

export default MockInterviews;
